import environment from "environment";
// const hostLambda = environment.baseApiLambda;
const base = `//www.dreamchimney.com/api`;
export const urlTracksPopularLastWeek = base + "/tracks/popular/last-week";
export const urlTracksRecent = base + "/tracks/recent";
export const urlTrackFeatured = base + "/tracks/featured_otd";

export const urlTracksOneYearAgo = base + "/tracks/daysago/365";
export const urlTracksTwoYearsAgo = base + "/tracks/daysago/730";
export const urlTracksThreeYearsAgo = base + "/tracks/daysago/1095";

// export const urlTrackArchive = `${hostLambda}/tracks-archive`;

// @TODO migration node js api
export const urlTrackArchive = base + `/tracks/archive`;

export const getTracksPopularLastWeek = (axios) => axios.get(urlTracksPopularLastWeek);
export const getTracksRecent = (axios) => axios.get(urlTracksRecent);
export const getTrackFeatured = (axios) => axios.get(urlTrackFeatured);
export const getTrackArchive = (axios, page = 1) => axios.get(`${urlTrackArchive}?page=${page}`);

export const getTracksOneYearAgo = (axios) => axios.get(urlTracksOneYearAgo);
export const getTracksTwoYearsAgo = (axios) => axios.get(urlTracksTwoYearsAgo);
export const getTracksThreeYearsAgo = (axios) => axios.get(urlTracksThreeYearsAgo);
